import { ConnectedAccountChargeStatus } from '@40seas/entities/connected-accounts';
import { EnumColor } from '@40seas/frontend/common/providers';

export const ConnectedAccountChargeStatusMapping = {
    [ConnectedAccountChargeStatus.Done]: 'success',
    [ConnectedAccountChargeStatus.Pending]: 'info',
    [ConnectedAccountChargeStatus.InProgress]: 'secondary',
    [ConnectedAccountChargeStatus.Suspended]: 'error',
    [ConnectedAccountChargeStatus.Failed]: 'error',
} as { [key in ConnectedAccountChargeStatus]: EnumColor };
